import { useQuery } from "@tanstack/react-query";
import { getCalibrationReport } from "./api";

// useCalibrationReport fetches the calibration report for the current window.
export function useCalibrationReport() {
  return useQuery({
    queryKey: ["financial-control-calibration-report"],
    queryFn: getCalibrationReport,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
